<template>
  <div class="mr-2">
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        indeterminate
        :size="50"
      />
    </div>

    <TitleCard
      class="mt-4"
      :is-edit-mode="false"
      v-show="dataLoaded"
      :disabled="isLoadingSave"
    />

    <v-row
      v-show="dataLoaded"
      class="mb-0 mt-2"
    >
      <v-col
        ref="workList"
        cols="12"
        class="pt-1 pb-2 pr-2 overflow-auto"
      >
        <PersonalDataCard :selected-employee="employee" />

        <PositionsCard
          class="mt-4"
          :selected-employee="employee"
        />

        <EditorialBoardCard
          class="mt-4"
          :selected-employee="employee"
        />
        <IndicatorsOfScientificActivity
          class="mt-4"
          :selected-employee="employee"
          :is-loading-save="isLoadingSave"
          :is-no-changes="isNoChanges"
          @updateEmployee="updateEmployee"
          @save="saveEmployee"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Employee } from '../models'
import { employeeApi, journalEditorialBoardApi } from '../api'
import PersonalDataCard from '../components/Employee/PersonalDataCard'
import PositionsCard from '../components/Employee/PositionsCard'
import IndicatorsOfScientificActivity from '../components/Employee/IndicatorsOfScientificActivity'
import TitleCard from '@/components/Works/elements/TitleCard.vue'
import { workListHeight } from '@/mixins/workListHeight'
import EditorialBoardCard from '../components/Employee/EditorialBoardCard.vue'

export default {
  name: 'Employee',

  metaInfo: {
    title: 'Сотрудник'
  },

  components: {
    TitleCard,
    IndicatorsOfScientificActivity,
    PositionsCard,
    PersonalDataCard,
    EditorialBoardCard
  },

  mixins: [workListHeight],

  created() {
    this.dataLoaded = false
    this.getEmployee()
    this.findActualizationJournals()
  },

  data: () => ({
    employee: new Employee(),
    actualizeJournals: [],
    dataLoaded: false,
    isLoadingSave: false,
    isNoChanges: true
  }),

  methods: {
    async getEmployee() {
      try {
        const data = await employeeApi.getCurrent()
        this.employee = new Employee(data)
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить информацию о сотруднике')
      } finally {
        this.dataLoaded = true
      }
    },

    async findActualizationJournals() {
      try {
        this.actualizeJournals = await journalEditorialBoardApi.findActualizationForCurrentUser()
      } catch (e) {
        console.error(e)
      }
    },

    updateEmployee(item) {
      this.isNoChanges = false
      this.employee = new Employee(item)
    },

    async saveEmployee() {
      try {
        this.isLoadingSave = true
        const body = this.employee.getForAPI()
        const data = await employeeApi.update(body)
        this.employee = new Employee(data)
        this.$toast.info('Успешно сохранено')
        this.isNoChanges = true
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.isLoadingSave = false
      }
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  }
}
</script>

<style scoped></style>
